// Import Dependencies
import React, { Component } from 'react';

// Import Stylesheet
import styles from './reCaptchaAttribution.css';

export default class ReCaptchaAttribution extends Component {
    renderPrivacyLink(text) {
        return (
            <a
                className={styles.termsConditionsLink}
                href="https://policies.google.com/privacy"
                rel="nofollow"
                target="_blank"
            >{text}</a>
        );
    }
    renderTermsOfServiceLink(text) {
        return (
            <a
                className={styles.termsConditionsLink}
                href="https://policies.google.com/terms"
                rel="nofollow"
                target="_blank"
            >{text}</a>
        );
    }

    render() {
        return (
            <div>
                <p className={styles.termConditions}>
                    This site is protected by reCAPTCHA and the Google {this.renderPrivacyLink('Privacy Policy')} and {this.renderTermsOfServiceLink('Terms of Service')} apply.
                </p>
            </div>
        );
    }
}
